import React, { createContext, useState } from 'react';

interface ImpersonationState {
  astrologerId: string;
  astrologerName: string;
  astrologerUserId: string;
}

interface ImpersonationContextValue extends ImpersonationState {
  startImpersonation: (state: ImpersonationState) => void;
  stopImpersonation: () => void;
}

export const ImpersonationContext = createContext<ImpersonationContextValue | null>(null);

export function ImpersonationProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<ImpersonationState | null>(null);

  function startImpersonation(s: ImpersonationState) { setState(s); }
  function stopImpersonation()                       { setState(null); }

  return (
    <ImpersonationContext.Provider value={state ? { ...state, startImpersonation, stopImpersonation } : null as unknown as ImpersonationContextValue}>
      {children}
    </ImpersonationContext.Provider>
  );
}
